import { type MetaFunction } from '@remix-run/node'
import productLife from './product-life.png'

export const meta: MetaFunction = () => [
	{ title: 'Life Insurance' },
	{
		name: 'description',
		content: 'We offer life insurance options.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Types of Life Insurance</h1>
			<img
				src={productLife}
				alt="A man holding flowers in a cemetery."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Life insurance
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Coverage as a job to be done- there are many reasons why life insurance
				is purchased. When considering it, there are a number of factors to take
				into account in your decision-making process. Because of a variety of
				circumstances that bring a person to the point of turning to life
				insurance as a solution, there are also several approaches to using life
				insurance to solve those problems.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Term
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Term insurance is ideal when you have a specific need for a death
				benefit to be paid but only if the death occurs during a set period of
				time, known as the term. For instance, a bank may require a life
				insurance policy pledged as collateral for a loan to act as a guarantee
				of repayment. It is a popular choice when the need exists for a strictly
				temporary policy. There are pros and cons. Some of the cons are that the
				policy expires or becomes significantly more expensive at the end of the
				term. Some of the pros are that some term policies have a conversion
				privilege that enables you to convert the policy into a different type
				of policy that may last longer, in exchange for a difference in premium.
				For example, if you are in the 19th year of a 20 year policy, and
				develop cancer, you might choose to exercise the conversion privilege
				and convert all or part of the death benefit into a whole or universal
				life policy. The premium would be higher than what you had become
				accustomed to paying on the term policy, but it would be a lot less than
				if you had reached the end of the 20 year policy and allowed it to renew
				beyond the 20 years - often raising substantially each year beyond the
				expiration of the term. Con: No cash value accumulates in a term policy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Whole
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Whole life insurance is based on guarantees and is designed to last
				until you die or until age (100?). This policy usually accumulates a
				cash value within the policy which can be borrowed against or the policy
				can be cashed out, returning the surrender value to the policy owner.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Universal
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Universal insurance is a type of blended policy that combines some of
				the benefits of term insurance and some of the benefits of whole life
				insurance. It may be the best choice.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				How will my rate be determined?
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				health & lifestyle
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				family history
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				age
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				gender
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				for term and universal insurance the rate is heavily driven by the
				length that the coverage will last.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				*** Look at life insurance buyers guide for additional ideas for content
				and frequently asked questions
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Please perform this self assessment by asking yourself the following
				questions.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. “If I die tomorrow, will the amount of life insurance benefit be
				sufficient to meet the needs of my surviving family and other financial
				obligations?”
			</p>
		</main>
	)
}
